import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import IconButton from 'material-ui/IconButton';
import Close from '../Icons/Close';
import PromotePlanChangeDialog from '../common/PromotePlanChangeDialog';
import { PromotePlanDialogTypes } from '../../constants/ComponentTypes'

const styles = {
  banner: {
    width: '100%',
    background: 'transparent linear-gradient(90deg, #1A65FF 0%, #1BB5A4 100%) 0% 0% no-repeat padding-box',
    height: '67px',
    position: 'relative',
    overflow: 'hidden',
  },

  container: {
    maxWidth: '1230px',
    width: '100%',
    margin: 'auto',
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },

  type: {
    color: '#FFFFFF',
    fontSize: '15px',
    fontWeight: 'bold'
  },

  link: {
    textDecoration: 'underline',
    cursor: 'pointer'
  },

  bannerCloseBtn: {
    width: '24px',
    height: '24px',
    verticalAlign: 'unset',
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: '20px',
    top: '50%',
    transform: 'translateY(-50%)'
  }
};

class NotificationBanner extends React.Component {
  state = {
    showBanner: JSON.parse(sessionStorage.getItem('showNotificationBanner')) === null ? true : JSON.parse(sessionStorage.getItem('showNotificationBanner')),
    [PromotePlanDialogTypes.REACTION_KEYWORD.flag]: false,
  }

  toggleBanner = () => {
    this.setState({ showBanner: false });
    sessionStorage.setItem('showNotificationBanner', false);
  }

  toggleContactDialog = (type) => {
    this.setState({ [type["flag"]]: !(this.state[type["flag"]]) });
  }

  renderContactDialog = (type) => {
    if (this.state[type["flag"]]) {
      return (
        <PromotePlanChangeDialog
          isOpen={this.state[type["flag"]]}
          type={type}
          toggleDialog={() => this.toggleContactDialog(type)}
        />
      )
    }
  }

  render() {
    const { classes, user } = this.props;

    // eslint-disable-next-line no-constant-condition
    if (this.state.showBanner && (
      user &&
      user.active_plan &&
      false // TODO: 新たにバナーを表示するかどうかを判断する条件を追加してください。現在は必ずelseに流れるようになっています。
    )) {
      return (
        <div className={classes.banner}>
          <div className={classes.container}>
            <img
              src={require('../../assets/images/notification-banner-img@2x.png')}
              alt="banner"
              height="100%"
              style={{ marginRight: '20px' }} />
            <a className={classNames(classes.type, classes.link)} onClick={() => this.toggleContactDialog(PromotePlanDialogTypes.RECOMMEND)}><span role="img" aria-label="img">🎉🎉🎉【</span>新機能】ターゲットレコメンド機能をリリースしました!!! \ 今なら先着5社限定で特別キャンペーン中 /</a>
          </div>
          <IconButton className={classes.bannerCloseBtn} onClick={this.toggleBanner}>
            <Close color="#FFFFFF" width="20" height="20" />
          </IconButton>
          {this.renderContactDialog(PromotePlanDialogTypes.RECOMMEND)}
        </div>
      )
    } else {
      return <div style={{ display: 'none' }}></div>;
    }
  }
}

NotificationBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
};

export default withStyles(styles)(NotificationBanner);



// WEBPACK FOOTER //
// ./src/components/common/NotificationBanner.jsx